// ImageCanvas.jsx (Reusable Component)
import React from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import ThumbnailPicker from "../../components/ThumbnailPicker/ThumbnailPicker";
import trashIcon from "../../assets/images/trash-03.svg";

const ImageCanvas = ({
  show,
  onHide,
  images,
  onImageAdd, // Make sure this prop is included
  onImageDelete,
  onSave,
  isUploading,
  isAdding,
  onClear, // New prop to handle clearing images
}) => {
  const getImageUrl = (url) => {
    return url.startsWith("https://")
      ? url
      : `${process.env.REACT_APP_S3_URL}/${url}`;
  };

  const handleClose = () => {
    onClear(); // Clear images when closing
    onHide(); // Call the original onHide
  };

  return (
    <Offcanvas show={show} onHide={handleClose} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>
          {images.length >= 1 ? "Manage Images" : "Add Image"}
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="add_buyer_content">
          <div className="row">
            {/* Display existing images with delete option */}
            {images.map((image, index) => (
              <div className="col-md-6" key={index}>
                <div
                  key={index}
                  className="option-card"
                >
                  <img
                    src={getImageUrl(image)}
                    alt={`Preview ${index}`}
                    className="opt-car-img"
                  />
                  <button
                    className="action_button"
                    onClick={() => onImageDelete(index)}
                  >
                    <img src={trashIcon} alt="delete" />
                  </button>
                </div>
              </div>
            ))}

            {/* Image uploader - only show if we haven't reached max */}
            {images.length < 4 && (
              <div
                className="upload-wrap"
              >
                <ThumbnailPicker
                  height="120px"
                  onFileSelect={(file) => onImageAdd(file)}
                  accept={"image/*"}
                  required
                  disabled={isUploading || isAdding}
                />
                <p style={{ color: "#666", marginTop: "10px" }}>
                  {4 - images.length} more can be added (max 4)
                </p>
                {isAdding && (
                  <p style={{ color: "blue", marginTop: "5px" }}>
                    Uploading image...
                  </p>
                )}
              </div>
            )}
          </div>
          <div className="addBuyer_submit-btn" style={{ marginTop: "20px" }}>
            <button
              className="btn btn-success"
              type="button"
              onClick={onSave}
              disabled={isUploading || images.length === 0}
            >
              {isUploading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Saving...
                </>
              ) : (
                "Save Changes"
              )}
            </button>
          </div>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default ImageCanvas;
